module.exports = __webpack_public_path__ + "img/goods1_4.845f34d9.jpg";